// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "recommend-NKApG";
var _4 = "recommend__icon-cQmGD";
var _5 = "slider-3p8ph";
export { _1 as "__esModule", _2 as "mobile", _3 as "recommend", _4 as "recommend__icon", _5 as "slider" }
export default { "__esModule": _1, "mobile": _2, "recommend": _3, "recommend__icon": _4, "slider": _5 }
